import { type EditorType } from '@/components/tiptap/types/index.enums';
import { toSectionEditorContext } from '@/components/tiptap/vMarkdown/editor-type';
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type SectionCreationMethod } from '@/models/analytics/features/notes';
import { type Editor } from '@tiptap/react';
import { type SectionNodeStorage } from './section-node';

/**
 * Reads the host editor type stamped onto `SectionNode` storage by
 * `BlockEditorMarkdown`. Used by the editor-driven creation paths (the `# `
 * input rule and the `/section` slash command) to report `editor_context`
 * without React context. Falls back to `undefined` when storage is absent.
 */
export function getSectionEditorType(editor: Editor | undefined): EditorType | undefined {
  return (
    editor?.storage as unknown as
      | Record<string, SectionNodeStorage | undefined>
      | undefined
  )?.sectionNode?.editorType;
}

/**
 * Fires `section_created` for the editor-driven creation paths that run outside
 * React (input rule, slash command), dispatching via the Redux `store`.
 */
export function trackSectionCreated(
  editorType: EditorType | undefined,
  creationMethod: SectionCreationMethod
): void {
  track({
    event_name: TrackingEventName.SectionCreated,
    props: {
      creation_method: creationMethod,
      editor_context: toSectionEditorContext(editorType),
      editor_type: 'vmarkdown',
    },
    options: { amplitude: false },
  });
}
